/**
 * @generated SignedSource<<d4dd672b34e2e0946069ef0c17040f8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useOrgAdminUserRelayByEmailQuery$variables = {
  email: string;
  organizationId: string;
};
export type useOrgAdminUserRelayByEmailQuery$data = {
  readonly listAdminUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly adminOrganizationRoles: ReadonlyArray<{
          readonly id: string;
          readonly removedOn: any | null | undefined;
          readonly role: {
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly roleId: string;
        }>;
        readonly email: string;
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string;
      };
    }> | null | undefined;
  } | null | undefined;
};
export type useOrgAdminUserRelayByEmailQuery = {
  response: useOrgAdminUserRelayByEmailQuery$data;
  variables: useOrgAdminUserRelayByEmailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "eq",
                "variableName": "email"
              }
            ],
            "kind": "ObjectValue",
            "name": "email"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "AdminUserConnection",
    "kind": "LinkedField",
    "name": "listAdminUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUser",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "eq",
                            "variableName": "organizationId"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "organizationId"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "AdminOrganizationRole",
                "kind": "LinkedField",
                "name": "adminOrganizationRoles",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "removedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useOrgAdminUserRelayByEmailQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOrgAdminUserRelayByEmailQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "dfb69609eb3d4462ea62dab12d40c233",
    "id": null,
    "metadata": {},
    "name": "useOrgAdminUserRelayByEmailQuery",
    "operationKind": "query",
    "text": "query useOrgAdminUserRelayByEmailQuery(\n  $email: String!\n  $organizationId: ID!\n) {\n  listAdminUsers(filter: {email: {eq: $email}}, first: 1) {\n    edges {\n      node {\n        id\n        email\n        firstName\n        lastName\n        adminOrganizationRoles(filter: {organizationId: {eq: $organizationId}}) {\n          id\n          roleId\n          removedOn\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae1a23c00dc5580b74f8abf59dd35bef";

export default node;
